<template>
  <f7-page login-screen class="login-page">
    <div class="login-hero">
      <img src="/icons/apple-touch-icon.png" alt="Pelikánec" class="login-logo" />
      <f7-login-screen-title>Pelikánec</f7-login-screen-title>
    </div>

    <f7-card class="login-card">
      <f7-card-content>
        <f7-button large tonal color="secondary" @click="auth(true)">
          <f7-icon ios="f7:globe" md="material:language" class="margin-right-half" />
          Prihlásiť sa cez Pelikán účet
        </f7-button>

        <template v-if="!showLoginForm">
          <f7-button class="margin-top" color="secondary" @click="forceLoginForm">
            Prihlásiť sa cez formulár
          </f7-button>
        </template>

        <template v-if="showLoginForm">
          <f7-block-title class="no-margin-horizontal login-form-divider"
            >Prihlásenie e-mailom</f7-block-title
          >
          <form @submit.prevent="auth(false)">
            <f7-list dividers-ios no-hairlines class="no-margin">
              <f7-list-input
                v-model:value.trim="email"
                label="E-mail"
                type="email"
                placeholder="Váš e-mail"
                @keydown.enter.prevent="closeKeyboard($event.target)"
              />
              <f7-list-input
                v-model:value="password"
                label="Heslo"
                type="password"
                placeholder="Vaše heslo"
                @keydown.enter.prevent="auth(false, $event.target)"
              />
            </f7-list>
          </form>
          <f7-button large tonal color="secondary" class="margin-top" @click="auth(false)">
            Prihlásiť sa
          </f7-button>
          <f7-button
            small
            color="primary"
            class="margin-top-half"
            @click="$emit('forgot-password')"
          >
            Zabudol som heslo
          </f7-button>
        </template>
      </f7-card-content>
    </f7-card>

    <f7-block class="text-align-center login-footer">
      <p>
        Táto aplikácia je určená výlučne zamestnancom a externistom firiem pod správou Pelican
        Travel Group.
      </p>
      <p>
        <f7-link external :href="PRIVACY_POLICY_URL" target="_blank" rel="noopener noreferrer">
          Zásady ochrany osobných údajov
        </f7-link>
      </p>
    </f7-block>
  </f7-page>
</template>
<script setup lang="ts">
import { getDevice } from 'framework7'
import { f7 } from 'framework7-vue'
import { onMounted, ref } from 'vue'

import { authenticate } from '@/assets/composables/auth'
import { loseFocus } from '@/assets/composables/utils'

defineEmits<{ 'forgot-password': [] }>()

const device = getDevice()

const hostname = ref<string>('')
const showLoginForm = ref<boolean>(false)

const email = ref<string>('')
const password = ref<string>('')
const PRIVACY_POLICY_URL = 'https://cestovanie.pelikan.sk/zasady-a-pravidla-ochrany-osobnych-udajov'

onMounted(() => {
  hostname.value = `${location.protocol}//${location.host}`
})

const auth = async (isOAuth: boolean, el?: HTMLElement) => {
  loseFocus(el)

  if (!isOAuth && (email.value === '' || password.value === '')) {
    f7.dialog.alert('Vyplňte prosím všetky polia.')
    return
  }

  if (isOAuth) {
    await authenticate(hostname.value, isOAuth)
  } else {
    await authenticate(undefined, isOAuth, { email: email.value, password: password.value })
  }

  email.value = ''
  password.value = ''
}

const closeKeyboard = (el?: HTMLElement) => {
  if (device.ios) {
    loseFocus(el)
    return
  }

  auth(false, el)
}

const forceLoginForm = () => {
  showLoginForm.value = true
}
</script>

<style scoped>
.login-page {
  --f7-login-screen-title-font-size: 28px;
  --f7-login-screen-title-font-weight: 700;
}

.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  padding-bottom: 24px;
}

.login-logo {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  margin-bottom: 8px;
}

.login-card {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.login-form-divider {
  margin-top: 24px;
}

.login-card :deep(.item-content.item-input) {
  margin-left: 0;
  margin-right: 0;
}

.login-footer {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  font-size: 12px;
  opacity: 0.6;
}
</style>
